import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function usePagination(initialPageSize = 10) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [pageSize, setPageSize] = useState(Number(searchParams.get('pageSize')) || initialPageSize);
  const [page, setPage] = useState(Number(searchParams.get('page')) || 1);

  const onPageChange = (page: number) => {
    setPage(page);

    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page.toString());

    setSearchParams(newParams);
  };

  const onPageSizeChange = (pageSize: number) => {
    setPageSize(pageSize);

    const newParams = new URLSearchParams(searchParams);
    newParams.set('pageSize', pageSize.toString());

    setSearchParams(newParams);
  };

  return {
    pageSize,
    setPageSize: onPageSizeChange,
    page,
    setPage: onPageChange,
  };
}
